<div class="circled-add-edit-link">
    <svg-icon src="../../../assets/svg/circled_plus.svg"></svg-icon>
    <div class="text">{{label}}</div>
</div>